import { DropdownOption } from "@benefitsui/app/lib/common.types";

export interface FormCellItemType {
  id: string;
  formsFlag: string;
  name: string;
  englishFormNumber: string;
  englishUrl: string;
  includedCoverages: string;
  includedPlanCodes: string;
  includedStates: string;
  excludedStates: string;
  portability?: boolean;
  acceleratedDeath: boolean;
  waiverOfPremium?: boolean;
  conversion: boolean;
}

export interface LeterFormCellItemType {
  policyId: string;
  statementDate: string;
  activityDate: string;
  planYear: string;
  fileUri?: string;
  fileId?: string;
}

export const stateList: DropdownOption<string>[] = [
    {key: "All", displayName: "Select..."},
    {key: "AL", displayName: "Alabama"},
    {key: "AK", displayName: "Alaska"},
    {key: "AZ", displayName: "Arizona"},
    {key: "AR", displayName: "Arkansas"},
    {key: "CA", displayName: "California"},
    {key: "CO", displayName: "Colorado"},
    {key: "CT", displayName: "Connecticut"},
    {key: "DE", displayName: "Delaware"},
    {key: "DC", displayName: "District Of Columbia"},
    {key: "FL", displayName: "Florida"},
    {key: "GA", displayName: "Georgia"},
    {key: "HI", displayName: "Hawaii"},
    {key: "ID", displayName: "Idaho"},
    {key: "IL", displayName: "Illinois"},
    {key: "IN", displayName: "Indiana"},
    {key: "IA", displayName: "Iowa"},
    {key: "KS", displayName: "Kansas"},
    {key: "KY", displayName: "Kentucky"},
    {key: "LA", displayName: "Louisiana"},
    {key: "ME", displayName: "Maine"},
    {key: "MD", displayName: "Maryland"},
    {key: "MA", displayName: "Massachusetts"},
    {key: "MI", displayName: "Michigan"},
    {key: "MN", displayName: "Minnesota"},
    {key: "MS", displayName: "Mississippi"},
    {key: "MO", displayName: "Missouri"},
    {key: "MT", displayName: "Montana"},
    {key: "NE", displayName: "Nebraska"},
    {key: "NV", displayName: "Nevada"},
    {key: "NH", displayName: "New Hampshire"},
    {key: "NJ", displayName: "New Jersey"},
    {key: "NM", displayName: "New Mexico"},
    {key: "NY", displayName: "New York"},
    {key: "NC", displayName: "North Carolina"},
    {key: "ND", displayName: "North Dakota"},
    {key: "OH", displayName: "Ohio"},
    {key: "OK", displayName: "Oklahoma"},
    {key: "OR", displayName: "Oregon"},
    {key: "PA", displayName: "Pennsylvania"},
    {key: "RI", displayName: "Rhode Island"},
    {key: "SC", displayName: "South Carolina"},
    {key: "SD", displayName: "South Dakota"},
    {key: "TN", displayName: "Tennessee"},
    {key: "TX", displayName: "Texas"},
    {key: "UT", displayName: "Utah"},
    {key: "VT", displayName: "Vermont"},
    {key: "VA", displayName: "Virginia"},
    {key: "WA", displayName: "Washington"},
    {key: "WV", displayName: "West Virginia"},
    {key: "WI", displayName: "Wisconsin"},
    {key: "WY", displayName: "Wyoming"}
  ];

